"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SubjectPathResolver = _interopRequireDefault(require("./SubjectPathResolver"));

var _solidAuthClient = _interopRequireDefault(require("solid-auth-client"));

var _dataModel = require("@rdfjs/data-model");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Creates a path with the current user as a subject.
 */


var UserPathHandler =
/*#__PURE__*/
function (_SubjectPathResolver$) {
  _inherits(UserPathHandler, _SubjectPathResolver$);

  function UserPathHandler() {
    _classCallCheck(this, UserPathHandler);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserPathHandler).apply(this, arguments));
  }

  _createClass(UserPathHandler, [{
    key: "handle",
    value: function handle() {
      var subject = this.getWebId().then(_dataModel.namedNode);
      return this._createSubjectPath(subject);
    }
    /** Gets the WebID of the logged in user */

  }, {
    key: "getWebId",
    value: function () {
      var _getWebId = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var session;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _solidAuthClient.default.currentSession();

              case 2:
                session = _context.sent;

                if (session) {
                  _context.next = 5;
                  break;
                }

                throw new Error('Cannot resolve user path: no user logged in');

              case 5:
                return _context.abrupt("return", session.webId);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getWebId() {
        return _getWebId.apply(this, arguments);
      }

      return getWebId;
    }()
  }]);

  return UserPathHandler;
}(_SubjectPathResolver.default);

exports.default = UserPathHandler;